<div class='header'>
  <div class='title-area'>
    <h2 class='title' [hidden]='detailsVisible'>Add Song</h2>
    <button class='cancel' [hidden]='detailsVisible' (click)='cancel()'>Cancel</button>
    <button class='back' [hidden]='!detailsVisible' (click)='back()'><i class='mt-left'></i>Back</button>
    <button class='add-song' [hidden]='!detailsVisible' (click)='addSong()'><i class='mt-plus'></i>Add Song</button>
  </div>
</div>

<div class='add-song-section' [hidden]='detailsVisible'>
  <div class='selectors'>
    <!-- <p class='error' >You need 2 more SWOW</p>
    <p class='error'>You need 3 more XYZ</p> -->
    <div class='slider'>
      <button class='library' [ngClass]='{"selected": mtLibrarySelected}' (click)='selectMTLibrary()'>MT Library</button>
      <button class='custom' [ngClass]='{"selected": !mtLibrarySelected}' (click)='selectCustomSong()'>Custom Song</button>
    </div>
    <div class='library-options' [hidden]='!mtLibrarySelected'>
      <div class='searchers'>
        <div class='search'>
          <label>Search</label>
          <input placeholder='Name or Info' [(ngModel)]='searchText'>
        </div>
        <div class='sort'>
          <label>Sort</label>
          <button (click)='chooseSortOrder($event)'>{{sortOrder}}<i class='mt-arrow-down'></i></button>
        </div>
      </div>
      <div class='collection'>
        <label>Select Collection</label>
        <button (click)='chooseCollection($event)'>{{selectedCollection ? selectedCollection.name : 'None'}}</button>
      </div>

      <div class='filter-controls'>
          <button class='toggle-filters' (click)='toggleFilters()'>{{toggleFiltersText}}</button>
          <button class='clear-filters' [hidden]='!anyFilterSelected()' (click)='clearFilters()'>Clear Filters</button> 
          <p class='song-count'>{{displayedSongs.length}} Songs</p>    
      </div>

      <div class='filters' [hidden]='!filtersVisible'>
        <div class='divider'></div>
        <div>
          <!-- <p>Tonality</p> -->
          <div class='options'>
            <button class='pill' [ngClass]='{"selected": filter.majorSelected}' (click)='toggleMajor()'>Major</button>
            <button class='pill' [ngClass]='{"selected": filter.nonmajorSelected}' (click)='toggleNonMajor()'>Non-Major</button>
          </div>
        </div>
        <div>
          <!-- <p>Meter</p> -->
          <div class='options'>
            <button class='pill' [ngClass]='{"selected": filter.dupleSelected}' (click)='toggleDuple()'>Duple</button>
            <button class='pill' [ngClass]='{"selected": filter.nondupleSelected}' (click)='toggleNonDuple()'>Non-Duple</button>
          </div>
        </div>
        <div>
          <!-- <p>Words</p> -->
          <div class='options'>
            <!-- <button class='words pill' [ngClass]='{"selected": filter.wordsSelected}' (click)='toggleWords()'>Words</button> -->
            <button class='pill' [ngClass]='{"selected": filter.swowSelected}' (click)='toggleSWOW()'>SWOW</button>
          </div>
        </div> 
      </div>      
    </div>
  </div>

  <div class='library-songs' [hidden]='!mtLibrarySelected'>
    <div class='song' *ngFor='let song of displayedSongs; trackBy: trackItem'>
      <div class='plus' (click)='addSelectedSong(song)'><i class='mt-plus'></i></div>
      <div class='content' (click)='addSelectedSong(song)'>
        <h3 class='title'>{{song.name}}</h3>
        <label class='used'>Used: {{course.songUsedCount(song)}} times</label>
        <div class='info'>
          <label class='tonality'>{{song.formattedTonality}}</label>
          <label *ngIf='song.isSwow' class='words'>{{song.isSwow ? 'SWOW' : 'Words'}}</label> <!-- #213 -->
          <label class='meter'>{{song.meter}}</label>
        </div>
      </div>
      <div class='more' (click)='showDetails(song)'><i class='mt-right'></i></div>
    </div>
  </div>

  <div class='custom-song' [hidden]='mtLibrarySelected'>
    <div class='content'>
      <div class='labeled-entry'>
        <label>Song Name</label>
        <input class='song-name' placeholder='Mary Had a Little Lamb' [(ngModel)]="customLessonSong.name">
      </div>
      <div class='divider'></div>
      <div class='selections'>
        <div class='labeled-entry'>
          <label>Key</label>
          <button class='key' (click)='chooseKey($event)'>{{customLessonSong.key.length > 0 ? customLessonSong.key : 'Select...'}}</button>
        </div>
        <div class='labeled-entry'>
          <label>Meter</label>
          <button class='meter' (click)='chooseMeter($event)'>{{customLessonSong.meter.length > 0 ? customLessonSong.meter : 'Select...'}}</button>
        </div>
        <div class='labeled-entry'>
          <label>Tonality</label>
          <button class='tonality' (click)='chooseTonality($event)'>{{customLessonSong.tonality.length > 0 ? customLessonSong.tonality : 'Select...'}}</button>
        </div>
        <div class='labeled-entry'>
          <label>Starting Pitch</label>
          <button class='pitch' (click)='chooseStartingPitch($event)'>{{customLessonSong.startingPitch.length > 0 ? customLessonSong.startingPitch : 'Select...'}}</button>
        </div>
        <div class='labeled-entry'>
          <label>SWOW</label>
          <button class='swow' (click)='chooseHasWords($event)'>{{customLessonSong.isSwow != null ? (customLessonSong.isSwow ? 'SWOW' : 'Words') : 'Select...'}}</button>
        </div>
      </div>
      <div class='divider'></div>
      <div class='labeled-entry'>
        <label>Recording Link (Optional)</label>
        <div class='input-with-icon'>
          <input class='song-name' placeholder='YouTube, iTunes, etc.' [(ngModel)]='customLessonSong.url'>
          <i class='mt-play' [hidden]='!customLessonSong.url' (click)='playCustomSong()'></i>
        </div>
      </div>
      <button class='add' (click)='addCustomSong()'>Add</button>
    </div>     
  </div> 
</div>

<div class='song-detail-section' [hidden]='!detailsVisible'>
  <app-song-detail [course]='course' [song]='detailSong' [isVisible]='detailsVisible'></app-song-detail>
</div>
